import angular from 'angular';

angular.module('cxTable').directive('cxTableRow', [
  '$compile',
  function($compile) {
    return {
      restrict: 'A',
      priority: 1001,
      terminal: true,
      require: '^^cxTable',
      compile: function(el, attrs) {
        var rowVar = attrs.cxTableRow || 'row';
        el.removeAttr('cx-table-row'); //Remove own attribute to prevent endless compile loop
        //Inject ng-repeat with necessary filters & sorting
        return function(scope, element, attributes, cxTable) {
          if (cxTable.paging) {
            element.attr('ng-repeat', rowVar + ' in table.rows'); //Add ng-repeat to element
          } else {
            element.attr(
              'ng-repeat',
              rowVar +
                ' in table.rows | filter:table.tableInfo.search | filter:table.filterTable | orderBy:table.tableInfo.sortBy:table.tableInfo.sortDesc',
            ); //Add ng-repeat to element
          }
          $compile(element, null, 1001)(scope); //Recompile
        };
      },
    };
  },
]);
